import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-empty-side-panel',
  templateUrl: './empty-side-panel.component.html',
  styleUrls: ['./empty-side-panel.component.scss'],
  standalone: false,
})
export class EmptySidePanelComponent {
  readonly showCtaButton = input<boolean>(true);
  readonly emptyViewSvg = input<string>('plus');
  readonly emptyViewText = input<string>('');
  readonly emptyViewTitle = input<string>('');
  readonly ctaButtonText = input<string>('');
  readonly isCtaBtnDisabled = input<boolean>(false);
  readonly ctaButtonClick = output();
}
